import { Keyword } from "@siteimprove/alfa-css";
import { Preference } from "@siteimprove/alfa-device";
import { None, Option } from "@siteimprove/alfa-option";
import { Media } from "./media.js";
export var Discrete;
(function (Discrete) {
    function discrete(name, keywords, getDeviceValue, booleanFalse) {
        return class Discrete extends Media {
            static of(value) {
                return new Discrete(Option.of(value));
            }
            static _boolean = new Discrete(None);
            constructor(value) {
                super(name, value);
            }
            static boolean() {
                return Discrete._boolean;
            }
            matches(device) {
                const deviceValue = getDeviceValue(device);
                return this._value
                    .map((value) => value.matches(Keyword.of(deviceValue)))
                    .getOr(deviceValue !== (booleanFalse ?? "none"));
            }
            static _from(value) {
                return value.map(Discrete.of).getOrElse(Discrete.boolean);
            }
            static parse = Media.parseDiscrete(name, Discrete._from, ...keywords);
        };
    }
    function userPreference(name) {
        return discrete(name, [...Preference.preferences[name]], (device) => device.preference(name).value, Preference.unset(name));
    }
    Discrete.Orientation = discrete("orientation", ["landscape", "portrait"], (device) => device.viewport.orientation);
    Discrete.ForcedColors = userPreference("forced-colors");
    Discrete.Inverted = userPreference("inverted");
    Discrete.PrefersColorScheme = userPreference("prefers-color-scheme");
    Discrete.PrefersContrast = userPreference("prefers-contrast");
    Discrete.PrefersReducedData = userPreference("prefers-reduced-data");
    Discrete.PrefersReducedMotion = userPreference("prefers-reduced-motion");
    Discrete.PrefersReducedTransparency = userPreference("prefers-reduced-transparency");
})(Discrete || (Discrete = {}));
//# sourceMappingURL=discrete.js.map